module.exports = __webpack_public_path__ + "img/alerts-6-mobile.e43e41b8.gif";